/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10.0034 11.5924C10.1872 11.1882 10.2791 10.986 10.4084 10.813C10.5232 10.6594 10.6594 10.5232 10.813 10.4084C10.986 10.2791 11.1882 10.1872 11.5924 10.0034L16 8L13.9966 12.4076C13.8128 12.8118 13.7209 13.014 13.5916 13.187C13.4768 13.3406 13.3406 13.4768 13.187 13.5916C13.014 13.7209 12.8118 13.8128 12.4076 13.9966L8 16L10.0034 11.5924Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16 8L12.1387 9.75515C11.5323 10.0308 11.2291 10.1686 10.9694 10.3627C10.7392 10.5348 10.5348 10.7392 10.3627 10.9694C10.1686 11.2291 10.0308 11.5323 9.75515 12.1387L8 16L11.8613 14.2448C12.4677 13.9692 12.7709 13.8314 13.0306 13.6373C13.2608 13.4652 13.4652 13.2608 13.6373 13.0306C13.8314 12.7709 13.9692 12.4677 14.2448 11.8613L16 8Z"
				fill="currentColor"
			/>
			<path
				d="M9.75515 12.1387C10.0308 11.5323 10.1686 11.2291 10.3627 10.9694C10.5348 10.7392 10.7392 10.5348 10.9694 10.3627C11.2291 10.1686 11.5323 10.0308 12.1387 9.75515L16 8L14.2448 11.8613C13.9692 12.4677 13.8314 12.7709 13.6373 13.0306C13.4652 13.2608 13.2608 13.4652 13.0306 13.6373C12.7709 13.8314 12.4677 13.9692 11.8613 14.2448L8 16L9.75515 12.1387Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM16.1172 8.94212C16.3904 8.34111 16.527 8.04061 16.4707 7.85888C16.4219 7.70143 16.2986 7.57815 16.1411 7.52934C15.9594 7.47301 15.6589 7.6096 15.0579 7.88278L12.3099 9.13187C11.5014 9.49938 11.0971 9.68314 10.7509 9.9419C10.4439 10.1714 10.1714 10.4439 9.9419 10.7509C9.68314 11.0971 9.49938 11.5014 9.13187 12.3099L7.88278 15.0579C7.6096 15.6589 7.47301 15.9594 7.52934 16.1411C7.57815 16.2986 7.70143 16.4219 7.85888 16.4707C8.04061 16.527 8.34111 16.3904 8.94211 16.1172L11.6901 14.8681C12.4986 14.5006 12.9029 14.3169 13.2491 14.0581C13.5561 13.8286 13.8286 13.5561 14.0581 13.2491C14.3169 12.9029 14.5006 12.4986 14.8681 11.6901L16.1172 8.94212Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8 2.83209C9.22493 2.2969 10.5778 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.74835 2.74418 7.67051 4 5.99902M16 8L11.5924 10.0034C11.1882 10.1872 10.986 10.2791 10.813 10.4084C10.6594 10.5232 10.5232 10.6594 10.4084 10.813C10.2791 10.986 10.1872 11.1882 10.0034 11.5924L8 16L12.4076 13.9966C12.8118 13.8128 13.014 13.7209 13.187 13.5916C13.3406 13.4768 13.4768 13.3406 13.5916 13.187C13.7209 13.014 13.8128 12.8118 13.9966 12.4076L16 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9.75515 12.1387C10.0308 11.5323 10.1686 11.2291 10.3627 10.9694C10.5348 10.7392 10.7392 10.5348 10.9694 10.3627C11.2291 10.1686 11.5323 10.0308 12.1387 9.75515L16 8L14.2448 11.8613C13.9692 12.4677 13.8314 12.7709 13.6373 13.0306C13.4652 13.2608 13.2608 13.4652 13.0306 13.6373C12.7709 13.8314 12.4677 13.9692 11.8613 14.2448L8 16L9.75515 12.1387Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M15.0579 7.88278L12.3099 9.13187C11.5014 9.49938 11.0971 9.68314 10.7509 9.9419C10.4439 10.1714 10.1714 10.4439 9.9419 10.7509C9.68314 11.0971 9.49938 11.5014 9.13187 12.3099L7.88278 15.0579C7.6096 15.6589 7.47301 15.9594 7.52934 16.1411C7.57815 16.2986 7.70143 16.4219 7.85888 16.4707C8.04061 16.527 8.34111 16.3904 8.94211 16.1172L11.6901 14.8681C12.4986 14.5006 12.9029 14.3169 13.2491 14.0581C13.5561 13.8286 13.8286 13.5561 14.0581 13.2491C14.3169 12.9029 14.5006 12.4986 14.8681 11.6901L16.1172 8.94212C16.3904 8.34111 16.527 8.04061 16.4707 7.85888C16.4219 7.70143 16.2986 7.57815 16.1411 7.52934C15.9594 7.47301 15.6589 7.6096 15.0579 7.88278Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
